<template>
  <div
    v-show="isActive"
    class="sidebar-order"
  >
    <div class="sidebar-header">
      <b-button
        v-if="step === 1"
        variant="flat-primary"
        class="btn-icon rounded-circle"
        @click="close"
      >
        <feather-icon
          icon="XIcon"
          size="24"
        />
      </b-button>
      <b-button
        v-if="step === 2"
        variant="flat-primary"
        class="btn-icon rounded-circle"
        @click="returnBack"
      >
        <feather-icon
          icon="ChevronLeftIcon"
          size="24"
        />
      </b-button>
      <div class="sidebar-title">
        Оформление заказа
      </div>
    </div>
    <div
      v-if="step === 1"
      class="sidebar-body"
    >
      <div class="sidebar-body__scroll">
        <h4 class="mb-2">
          Введите данные для получения билета
        </h4>
        <validation-observer
          #default="{ handleSubmit, invalid }"
          ref="refFormObserver"
        >
          <b-form
            @submit.prevent="handleSubmit(onSubmitStep1)"
            @reset.prevent="resetForm"
          >
            <validation-provider
              #default="validationContext"
              name="Имя и фамилия"
              rules="required"
              vid="name"
            >
              <b-form-group
                label-for="name"
                label="Имя и фамилия"
              >
                <b-form-input
                  id="name"
                  v-model="orderData.name"
                  trim
                  placeholder="Имя и фамилия"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="Электронная почта"
              rules="required|email"
              vid="email"
            >
              <b-form-group
                label-for="email"
                label="Почта"
              >
                <b-form-input
                  id="email"
                  v-model="orderData.email"
                  trim
                  placeholder="Электронная почта"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider
              #default="validationContext"
              name="Номер телефона"
              rules="required"
              vid="phone"
            >
              <b-form-group
                label-for="phone"
                label="Телефон"
              >
                <phone-field
                  id="phone"
                  v-model="orderData.phone"
                  autofocus
                  maxlength="18"
                  trim
                  placeholder="+7(999) 99-99-99"
                  :state="getValidationState(validationContext)"
                  validate
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="согласие"
              rules="required"
              vid="user_agreement"
            >
              <b-form-group>
                <b-form-checkbox
                  v-model="checkAgreementUser"
                  class="mb-1"
                  size="lg"
                  name="user_agreement"
                  :state="getValidationState(validationContext)"
                >
                  Я согласен с <a
                    target="_blank"
                    :href="getDocUrl('user_agreement')"
                  >Пользовательским соглашением</a> и <a
                    target="_blank"
                    :href="getDocUrl('privacy_policy')"
                  >Политикой конфиденциальности</a>
                </b-form-checkbox>
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="согласие на обработку персональных данных"
              rules="required"
              vid="personal_data"
            >
              <b-form-group>
                <b-form-checkbox
                  v-model="checkAgreementPersonal"
                  size="lg"
                  name="personal_data"
                  :state="getValidationState(validationContext)"
                >
                  Я согласен на обработку <a
                    target="_blank"
                    :href="getDocUrl('personal_data')"
                  >персональных данных</a>
                </b-form-checkbox>
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="согласие на получение рекламной рассылки"
              rules=""
              vid="personal_ad"
            >
              <b-form-group>
                <b-form-checkbox
                  v-model="orderData.isSubscribed"
                  size="lg"
                  name="personal_ad"
                  :state="getValidationState(validationContext)"
                >
                  Я&nbsp;согласен на&nbsp;<a
                    target="_blank"
                    :href="getDocUrl('receive_advertising')"
                  >получение рассылки</a>, содержащей информацию об&nbsp;изменении графика мероприятий, предоставляемых льготах, акциях и&nbsp;иного содержания.
                </b-form-checkbox>
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <div class="mt-2">
              <b-button
                variant="success"
                type="submit"
                :disabled="invalid || btnPaymentDisabled"
              >
                Далее
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </div>
    </div>
    <div
      v-if="step === 2"
      class="sidebar-body"
    >
      <div class="sidebar-body__scroll">
        <b>{{ eventName }}</b><br>
        {{ widgetFormatDate(eventDatetime) }}
        <hr style="width: 100%">
        <div class="tickets-count">{{ tickets.length }} {{ numWord(tickets.length, ['билет', 'билета', 'билетов']) }}:
        </div>
        <div v-for="ticket in tickets">
          <div class="ticket-item">
            <div class="ticket-item-detail">
              {{ ticket.row_sector }} ряд {{ ticket.seat_number }} место
              <div>{{ ticket.description }}</div>
            </div>
            <div class="ticket-item-price">
              <div
                v-show="ticket.price_old"
                class="ticket-item-price__old"
              >{{ formatMoney(ticket.price_old, 'RUB') }}
              </div>
              <div class="ticket-item-price__new">
                {{ formatMoney(ticket.price, 'RUB') }}
              </div>
            </div>
            <span
              :class="{'v-reset-input': true, 'v-reset-input-active': removeElementTicket}"
              @click="() => { removeElement(ticket.id) }"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14px"
                height="14px"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-x"
              >
                <line
                  x1="18"
                  y1="6"
                  x2="6"
                  y2="18"
                />
                <line
                  x1="6"
                  y1="6"
                  x2="18"
                  y2="18"
                />
              </svg>
            </span>
          </div>
        </div>

        <div
          v-if="commission"
          class="price-total"
        >
          <div class="ticket-item">
            <div class="ticket-item-detail">
              <b>Сервисный сбор ({{ commission }}%):</b>
            </div>
            <div class="ticket-item-price">
              {{ formatMoney(COMMISSION, 'RUB') }}
            </div>
          </div>
        </div>
        <div
          v-show="discount"
          class="price-total"
        >
          <div class="ticket-item">
            <div class="ticket-item-detail">
              <b>Скидка:</b>
            </div>
            <div class="ticket-item-price">
              <div class="ticket-item-price__new">
                {{ formatMoney(discount, 'RUB') }}
              </div>
            </div>
          </div>
        </div>
        <div class="price-total">
          <div class="ticket-item">
            <div class="ticket-item-detail">
              <b>Итоговая стоимость:</b>
            </div>
            <div class="ticket-item-price">
              {{ formatMoney(totalPriceWithCommission, 'RUB') }}
            </div>
          </div>
        </div>
        <div
          :isDisplayedPoints="$root.isDisplayedPoints"
          :isDisplayedBeneficiary="$root.isDisplayedBeneficiary"
          :hasPoints="hasPoints"
          :hasBeneficiary="hasBeneficiary"
          class="loyalty-block"
        >

          <div
            class="loyalty-block__item"
            role="tablist"
          >
            <div
              v-b-toggle="'collapse-promocode'"
              class="loyalty-block__head"
              @click="resetDiscount"
            >
              Использовать промокод
            </div>
            <b-collapse
              id="collapse-promocode"
              class="loyalty-block__body"
              accordion="my-accordion"
              role="tabpanel"
              visible
            >
              <div
                v-if="!btnApplyPromoCodeDisabled"
                class="loyalty-points__item"
              >
                <b-form-input
                  id="promocode"
                  v-model="orderData.promocode"
                  trim
                  placeholder="Ввести промокод"
                  :disabled="btnApplyPromoCodeDisabled"
                />
              </div>
              <div
                v-if="btnApplyPromoCodeDisabled"
                class="loyalty-points__item"
              >
                <div class="loyalty-points__used">
                  Скидка: {{ promocode.discount }}
                </div>
                <b-button
                  id="button-points-reset"
                  class="loyalty-points__delete"
                  type="button"
                  variant="link"
                  @click="resetDiscount"
                >
                  <feather-icon
                    icon="TrashIcon"
                    class="cursor-pointer"
                  />
                </b-button>
                <div
                  v-if="promocode.discount"
                  class="mt-1"
                >
                  <div
                    v-if="ticketsWithPromocode === 0"
                    class="alert alert-danger"
                    role="alert"
                  >
                    На&nbsp;данные места промокод не&nbsp;работает.
                  </div>
                  <div
                    v-if="ticketsWithPromocode > 0 && ticketsWithPromocode < tickets.length"
                    class="alert alert-warning"
                    role="alert"
                  >
                    Промокод действует&nbsp;на <b>{{ ticketsWithPromocode }} из {{ tickets.length }}</b> {{ numWord(tickets.length, ['билет', 'билета', 'билетов']) }}
                  </div>
                </div>
              </div>

              <b-button
                v-if="!btnApplyPromoCodeDisabled"
                id="promo"
                variant="success"
                :disabled="btnApplyPromoCodeDisabled || !orderData.promocode"
                @click="(event) => { calculation('promocode') }"
              >
                Применить
              </b-button>
            </b-collapse>
          </div>

          <div
            v-if="$root.isDisplayedPoints && hasPoints"
            class="loyalty-block__item"
            role="tablist"
          >
            <div
              v-b-toggle="'collapse-points'"
              class="loyalty-block__head"
              @click="resetDiscount"
            >
              Использовать баллы
            </div>
            <b-collapse
              id="collapse-points"
              class="loyalty-block__body"
              accordion="my-accordion"
              role="tabpanel"
            >
              <div class="loyalty-points">
                <div
                  v-if="!appliedPoints"
                  class="loyalty-points__item"
                >
                  <span class="loyalty-points__available">{{ userPoints }}</span> <span class="text-success">доступно</span>
                  <span class="d-none">{{ totalNumberPointsToPayPlanned }} <span>применится</span></span>
                </div>
                <div
                  v-if="appliedPoints"
                  class="loyalty-points__item"
                >
                  <div class="loyalty-points__used">
                    Баллы: -{{ totalNumberPointsToPay }}
                  </div>
                  <div class="loyalty-points__balans">
                    Осталось {{ totalRemainderPoints }} балла
                  </div>
                  <b-button
                    id="button-points-reset"
                    class="loyalty-points__delete"
                    type="button"
                    variant="link"
                    :disabled="btnApplyPointsDisabled"
                    @click="resetDiscount"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      class="cursor-pointer"
                    />
                  </b-button>
                </div>

                <div
                  v-if="showNotificationPoints"
                  class="loyalty-points__notification"
                >
                  Оплата баллами не превышает {{ userPointsResponse.percent_points_to_pay }}% от суммы заказа
                </div>

                <b-button
                  v-if="!appliedPoints"
                  id="button-points"
                  class="loyalty-points__apply"
                  type="button"
                  variant="success"
                  :disabled="btnApplyPointsDisabled"
                  @click="(event) => { calculation('points') }"
                >
                  Применить
                </b-button>
              </div>
            </b-collapse>
          </div>

          <div
            v-if="$root.isDisplayedBeneficiary && hasBeneficiary"
            class="loyalty-block__item"
            role="tablist"
          >
            <div
              v-b-toggle="'collapse-benefits'"
              class="loyalty-block__head"
              @click="resetDiscount"
            >
              Использовать льготы
            </div>
            <b-collapse
              id="collapse-benefits"
              class="loyalty-block__body"
              accordion="my-accordion"
              role="tabpanel"
            >
              <div class="loyalty-points">
                <div v-if="!limitError">
                  <div
                    v-if="!appliedBeneficiary"
                    class="loyalty-points__item"
                  >
                    <span class="loyalty-points__available">{{ userBeneficiaryResponse.beneficiary_percent }}% скидка</span>
                  </div>
                  <div
                    v-if="appliedBeneficiary"
                    class="loyalty-points__item"
                  >
                    <div class="loyalty-points__used">
                      Льгота (-{{ userBeneficiaryResponse.beneficiary_percent }}%): -{{ formatMoney(discount, 'RUB') }}
                    </div>
                    <b-button
                      v-if="appliedBeneficiary"
                      id="button-points-reset"
                      class="loyalty-points__delete"
                      type="button"
                      variant="link"
                      :disabled="btnApplyPointsDisabled"
                      @click="resetDiscount"
                    >
                      <feather-icon
                        icon="TrashIcon"
                        class="cursor-pointer"
                      />
                    </b-button>
                  </div>

                  <div
                    v-if="showNotificationBeneficiary"
                    class="loyalty-points__notification"
                  >
                    Уменьшите количество билетов на {{ bookingSeatExcessNumber }}
                  </div>
                  <b-button
                    v-if="!appliedBeneficiary"
                    id="button-benefits"
                    class="loyalty-points__apply"
                    type="button"
                    variant="success"
                    :disabled="btnApplyBeneficiaryDisabled"
                    @click="(event) => { calculation('beneficiary') }"
                  >
                    Применить
                  </b-button>
                </div>
                <div v-else>
                  Вам доступны льготы, но&nbsp;у&nbsp;нас закончились лимиты на&nbsp;льготные места в&nbsp;представлении&nbsp;&mdash; если&nbsp;Вы желаете оформить льготный билет, попробуйте выбрать мероприятие на&nbsp;другой день
                </div>
              </div>
            </b-collapse>
          </div>

        </div>
        <hr
          v-if="!sslCheckResult"
          style="width: 100%;"
        >
        <div
          v-if="!sslCheckResult"
          class="alert-sertificat-sber"
        >
          Для стабильной работы модуля оплаты Сбербанка могут потребоваться <a
            href="http://www.sberbank.ru"
            target="_blank"
          >сертификаты</a> Минцифры.
        </div>
        <div
          v-if="paymentButtons.length && showPaymentBtnBlock"
          class="mt-1 payment-buttons"
        >
          <div class="payment-buttons__head">
            Перейти к оплате
          </div>

          <button
            v-for="(btn, index) in paymentButtons"
            :key="index"
            :class="['go-pay-card', btn.class, { 'second': index > 0 }]"
            :disabled="btnPaymentDisabled || !tickets.length"
            @click="handlePaymentClick(btn, orderData)"
          >
            <span v-if="!loadingStatePay">
              <template v-if="btn.isSbpStyle">
                Оплатить <span class="icon-sbp" />
              </template>

              <template v-else>
                <span
                  class="icon-pay-card"
                  :class="{ 'vtb': btn.isVtb }"
                />
                <b>Картой</b>
                <template v-if="!btn.isVtb">
                  &nbsp; или <span class="icon-sber-pay" /> <b>SberPay</b>
                </template>
              </template>
            </span>

            <b-spinner
              v-if="loadingStatePay"
              small
            />
          </button>
        </div>
        <div
          v-if="!showPaymentBtnBlock"
          class="mt-1 payment-buttons"
        >
          <div class="payment-buttons__head">
            Перейти к оформлению заказа:
          </div>
          <button
            class="go-pay-card btn-sber-pay second"
            :disabled="btnPaymentDisabled"
            @click="$emit('done', orderData)"
          >
            <span v-if="!loadingStatePay">
              <b>Оформить заказ</b>
            </span>
            <b-spinner
              v-if="loadingStatePay"
              small
            />
          </button>
        </div>
        <div class="promo">
          <div v-if="showSberBanner">
            <img src="/images/sberbank/banner.svg">
          </div>
          <div class="sidebar-body__card-info">
            Работаем с картами любых<br>платёжных систем
            <img
              class="img-fluid mt-1"
              src="/images/main-page/payment_card.png"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCol,
  BCollapse,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormText,
  BRow,
  BTable,
  BTbody,
  BTd,
  BTr,
  VBToggle,
  BSpinner,
  BFormCheckboxGroup,
  BFormCheckbox,
} from 'bootstrap-vue'
import {
  ref, watch, onMounted, computed,
} from '@vue/composition-api'
import { localize, ValidationObserver, ValidationProvider } from 'vee-validate'
import ru from 'vee-validate/dist/locale/ru.json'
import formValidation from '@core/comp-functions/forms/form-validation'
import { email, required } from '@validations'
import vSelect from 'vue-select'
import phoneField from '@/libs/phone-field/PhoneFieldRu.vue'
import helpers from '@/mixins/globalHelpers'
import 'vue-select/dist/vue-select.css'
import store from '@/store'
import entityListsModule from '@/helpers/entityLists.module'
import useLegalDocuments from '@/views/composables/useLegalDocuments'
import loyaltySystemModule from './helpers/loyaltySystem.module'

localize({ ru })
localize('ru')

export default {
  components: {
    BTable,
    BTbody,
    BTr,
    BTd,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
    BCard,
    BCardHeader,
    BCardBody,
    BCardText,
    BCollapse,
    BForm,
    BFormText,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    phoneField,
    BSpinner,
    BFormCheckboxGroup,
    BFormCheckbox,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  mixins: [helpers],
  emits: ['done', 'close', 'removeElementFromSeats'],
  props: {
    event: {
      type: Object,
      required: true,
    },
    bookingSeat: {
      type: Array,
      required: true,
    },
    showModalErrorNotification: {
      type: Function,
      required: true,
    },
    eventName: {
      type: String,
      required: true,
    },
    eventDatetime: {
      type: String,
      required: true,
    },
    tickets: {
      type: Array,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    commission: {
      type: Number,
      require: true,
    },
    tPromo: {
      type: String,
      default: '',
      required: false,
    },
    loadingStatePay: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      required,
      email,
      phone: '+7',
    }
  },
  setup(props, context) {
    const sslCheckResult = ref(!!document.cookie.match(/^(.*;)?\s*skipSslCheck\s*=\s*[^;]+(.*)?$/))
    const sslCheck = () => {
      if (!sslCheckResult.value) {
        const e = new XMLHttpRequest()
        e.open('GET', 'https://www.sberbank.ru/', !0)
        e.addEventListener('load', (() => {
          document.cookie = 'skipSslCheck=true'
          sslCheckResult.value = true
        }))
        e.send()
      }
    }
    sslCheck()
    const buttonPaymentGateway1Enabled = computed(() => store.state.app.settings.button_payment_gateway_1_enabled)
    const buttonPaymentGateway2Enabled = computed(() => store.state.app.settings.button_payment_gateway_2_enabled)
    const buttonPaymentGateway1Type = computed(() => store.state.app.settings.payment_gateway_1_service_type)
    const buttonPaymentGateway2Type = computed(() => store.state.app.settings.payment_gateway_2_service_type)

    const paymentButtons = computed(() => {
      const buttons = []
      const configs = [
        {
          enabled: store.state.app.settings.button_payment_gateway_1_enabled,
          type: store.state.app.settings.payment_gateway_1_service_type,
        },
        {
          enabled: store.state.app.settings.button_payment_gateway_2_enabled,
          type: store.state.app.settings.payment_gateway_2_service_type,
        },
      ]

      configs.forEach(cfg => {
        if (cfg.enabled) {
          const isSbpStyle = ['sbp_cbr_qr', 'qr_vtb'].includes(cfg.type)
          const isVtbCard = cfg.type === 'rbs_vtb'

          buttons.push({
            type: cfg.type,
            isSbpStyle,
            isVtb: isVtbCard || cfg.type === 'qr_vtb', // Для иконки ВТБ, если нужно
            isSber: !isSbpStyle && !isVtbCard,
            class: isSbpStyle ? 'btn-sbp' : (isVtbCard ? 'btn-vtb-pay' : 'btn-sber-pay'),
            emit: isSbpStyle ? 'doneQr' : 'done',
          })
        }
      })
      return buttons
    })

    const handlePaymentClick = (btn, data) => {
      context.emit(btn.emit, data, btn.type)
    }

    const showSberBanner = computed(() => paymentButtons.value.some(btn => btn.isSber))

    const {
      applyDiscountPoints,
      applyDiscountBeneficiary,
      applyDiscountPromoCodes,
    } = loyaltySystemModule()
    const { getDocUrl, fetchSettingsFileDoc } = useLegalDocuments()
    const {
      fetchOrderLoyaltyTypes,
    } = entityListsModule()
    const loyaltyTypesList = ref([])
    const removeElementTicket = ref(true)
    const promocode = ref({})
    const setOrderLoyaltyTypes = (params = {}) => {
      const queryParams = {
        sortBy: 'id', sortDesc: false, page: 1, perPage: 30, ...params,
      }
      fetchOrderLoyaltyTypes(loyaltyTypesList, queryParams, false)
    }
    setOrderLoyaltyTypes()
    const orderData = ref({
      name: '',
      email: '',
      phone: '',
      promocode: null,
      paymentMethod: 1,
      loyalty_type: 'none',
      isSubscribed: false,
    })
    const step = ref(1)
    // const tiketsIdPromokod = ref([])
    const basketHall = () => {
      window.parent.postMessage({ message: 'kassy_widget_basket' }, '*')
    }
    const placeData = ref(JSON.parse(JSON.stringify(orderData)))
    const resetPlaceData = () => {
      placeData.value = JSON.parse(JSON.stringify(orderData))
    }
    const { refFormObserver, getValidationState, resetForm } = formValidation(resetPlaceData)
    const sbpEnabled = ref(false)
    const oldTotalPrice = ref(0.00) // Старая стоимость заказа если есть скидка
    const totalPrice = ref(0.00) // Общая стоимость заказа
    const totalPriceWithCommission = ref(0.00) // Общая стоимость заказа
    const discount = ref(0.00) // Скидка
    const COMMISSION = ref(0.00) // Комиссия
    const hasPoints = ref(false) // У пользователя есть баллы
    const hasBeneficiary = ref(false) // У пользователя есть льгота
    const limitError = ref(false) // У мероприятия закончились льготные места
    const userPointsResponse = ref([]) // Ответ по баллам
    const userBeneficiaryResponse = ref([]) // Ответ по льготам
    const appliedPoints = ref(false) // Применили баллы
    const appliedBeneficiary = ref(false) // Применили льготы
    const userPoints = ref(0) // Количество баллов у пользователя
    const totalRemainderPoints = ref(0) // Остаток баллов после применения
    const percentPointsToPay = ref(0) // Сколько процентов от стоимости можно применить для скидки у баллов
    const totalNumberPointsToPay = ref(0) // Сколько баллов можно применить для скидки
    const totalNumberPointsToPayPlanned = ref(0) // Сколько баллов можно применить для скидки планово

    const showNotificationPoints = ref(false) // Показывать сообщение если баллов больше чем можно применить
    const showNotificationBeneficiary = ref(false) // Показывать сообщение если билетов в заказе больше чем можно применить
    const bookingSeatExcessNumber = ref(0) // На сколько билетов в заказе больше чем можно применить

    const showPaymentBtnBlock = ref(true)

    const changeShowNotificationState = () => {
      // Если
      if (typeof userPointsResponse.value.points === 'number' && typeof userPointsResponse.value.percent_points_to_pay === 'number') {
        showNotificationPoints.value = userPointsResponse.value.points > (totalPrice.value / (100 / userPointsResponse.value.percent_points_to_pay))
      }
      // Если есть количество льготных билетов и оно меньше либо равно количеству билетов в заказе
      if (parseInt(userBeneficiaryResponse.value.beneficiary_number_benefits) && props.tickets.length <= parseInt(userBeneficiaryResponse.value.beneficiary_number_benefits)) {
        bookingSeatExcessNumber.value = 0
        showNotificationBeneficiary.value = false
      } else {
        userBeneficiaryResponse.value.beneficiary_number_benefits = parseInt(userBeneficiaryResponse.value.beneficiary_number_benefits) ?? 1
        bookingSeatExcessNumber.value = props.tickets.length - userBeneficiaryResponse.value.beneficiary_number_benefits
        showNotificationBeneficiary.value = true
      }
    }

    // кнопки делаем неактивными
    const btnApplyBeneficiaryDisabled = ref(false)
    const btnApplyPromoCodeDisabled = ref(false)
    const btnApplyPointsDisabled = ref(false)
    const btnPaymentDisabled = ref(false)

    const checkAgreementUser = ref([])
    const checkAgreementPersonal = ref([])

    const ticketsWithPromocode = ref(0)
    const isPromocodeApplied = ref(false)

    // Меняем состояние кнопки (активна - false, неактивна - true)
    const changeButtonsDisabledState = disabledState => {
      const isCartEmpty = !props.tickets || props.tickets.length === 0

      btnApplyPromoCodeDisabled.value = disabledState || isPromocodeApplied.value
      btnApplyPointsDisabled.value = disabledState || appliedPoints.value
      // Если есть количество льготных билетов и оно меньше либо равно количеству билетов в заказе
      if (!isCartEmpty && parseInt(userBeneficiaryResponse.value.beneficiary_number_benefits) && props.tickets.length <= parseInt(userBeneficiaryResponse.value.beneficiary_number_benefits)) {
        btnApplyBeneficiaryDisabled.value = disabledState
      } else {
        btnApplyBeneficiaryDisabled.value = true
      }
      btnPaymentDisabled.value = disabledState || isCartEmpty
    }

    watch(() => props.loadingStatePay, newLoadingStatePay => {
      changeButtonsDisabledState(newLoadingStatePay)
    })

    // Выводим модальное окно над виджетом
    const showModal = (message, title = null) => {
      context.emit('setErrorTitle', title ?? 'Внимание!')
      context.emit('setErrorMessage', message)
      props.showModalErrorNotification()
    }

    // Получаем данные о наличии данных (баллы и льготы) по email пользователя

    const fetchLoyaltySystemDataForUser = () => {
      const queryParams = {
        email: orderData.value.email,
        eventId: props.event.id,
        onlyFieldsPoints: ['points', 'percent_points_to_pay'],
        onlyFieldsBeneficiary: ['number_benefits', 'percent'],
        countSeats: props.tickets.length,
      }
      return store.dispatch('widget/fetchLoyaltySystemDataForUserEmail', queryParams)
        .then(response => response.data)
        .then(response => {
          const { data } = response
          hasPoints.value = response.data.hasPoints
          if (hasPoints.value) {
            userPointsResponse.value = response.data.userPointsResponse
            userPoints.value = Math.max(0, parseInt(Math.round(userPointsResponse.value.points)))
            if (userPoints.value < 1) {
              hasPoints.value = false
            }
            percentPointsToPay.value = userPointsResponse.value.percent_points_to_pay
            props.tickets.forEach((ticket, index) => {
              totalNumberPointsToPayPlanned.value += ticket.price - applyDiscountPoints(props.tickets[index].price, totalPrice.value, percentPointsToPay.value, userPoints.value)
            })
          }
          hasBeneficiary.value = response.data.hasBeneficiary
          limitError.value = response.data.limitError
          if (hasBeneficiary.value) {
            userBeneficiaryResponse.value = response.data.userBeneficiaryResponse
          }
          if (hasPoints.value || hasBeneficiary.value) {
            changeShowNotificationState()
          }

          return data
        })
        .catch(error => {
          btnApplyPromoCodeDisabled.value = false
          switch (error.response?.status) {
            case 403:
              showModal(error.response.data.message ?? 'У вас недостаточно прав для выполнения этого действия.', 'Доступ ограничен')
              break
            case 404:
              showModal(error.response.data.error)
              break
            case 422:
              orderProcessCancelSale(Object.values(error.response?.data?.errors)[0].join(', '), error.response?.data?.message)
              break
            default:
              showModal('Что-то пошло не так.', 'Ошибка')
              break
          }
          throw error
        })
    }
    // Расчитываем комиссию
    const calculationCommission = () => {
      COMMISSION.value = parseFloat((totalPrice.value / 100 * props.commission).toFixed(2))
    }

    // Общая стоимость заказа с учетом комиссии
    const calculationTotalPriceWithCommission = () => {
      calculationCommission()
      totalPriceWithCommission.value = totalPrice.value + COMMISSION.value
      btnPaymentDisabled.value = false
    }

    // Расчет стоимости заказа
    const calculationOrder = () => {
      let total = 0.00
      let oldTotal = 0.00
      let discountTicket = 0.00
      props.tickets.forEach(ticket => {
        total += parseFloat(ticket.price)
        if (typeof ticket.price_old !== 'undefined') {
          discountTicket += (ticket.price_old - ticket.price)
          oldTotal += ticket.price_old
        } else {
          oldTotal += ticket.price
        }
      })
      discount.value = discountTicket
      totalPrice.value = total
      oldTotalPrice.value = oldTotal
    }

    // Применяем промокод к заказу
    const applyPromoCode = () => {
      btnApplyPromoCodeDisabled.value = true
      isPromocodeApplied.value = true

      promocode.value.seats.forEach(seat => {
        props.tickets.forEach((ticket, index) => {
          if ([seat.seat_id].includes(ticket.id)) {
            const priceCurrent = props.tickets[index].price
            props.tickets[index].price_old = priceCurrent
            props.tickets[index].price = applyDiscountPromoCodes(promocode.value.type, priceCurrent, promocode.value.units)
          }
        })
      })

      ticketsWithPromocode.value = props.tickets.filter(ticket => ticket.price_old !== undefined).length

      calculationOrder()
      calculationTotalPriceWithCommission()
    }

    // Получаем промокод, применяем к местам и делаем перерасчет
    const applyPromoCodeToOrder = () => {
      btnApplyPromoCodeDisabled.value = true
      const queryParams = {
        is_online: 1,
        event_id: props.event.id,
        code: orderData.value.promocode,
      }
      store
        .dispatch('widget/searchPromocode', queryParams)
        .then(response => response.data)
        .then(response => {
          promocode.value = response.data
          applyPromoCode()
        })
        .catch(error => {
          isPromocodeApplied.value = false
          btnApplyPromoCodeDisabled.value = false
          changeButtonsDisabledState(false)
          switch (error.response?.status) {
            case 404:
              orderData.value.loyalty_type = 'none'
              orderData.value.promocode = null
              showModal(error.response.data?.message)
              break
            case 422:
              orderProcessCancelSale(Object.values(error.response?.data?.errors)[0].join(', '), error.response?.data?.message)
              break
            default:
              showModal('Что-то пошло не так.', 'Ошибка')
              break
          }
        })
    }

    // Применяем баллы к стоимости мест
    const applyPoints = () => {
      props.tickets.forEach((ticket, index) => {
        props.tickets[index].price_old = ticket.price
        props.tickets[index].price = applyDiscountPoints(props.tickets[index].price, totalPrice.value, percentPointsToPay.value, userPoints.value)
        totalNumberPointsToPay.value += props.tickets[index].price_old - props.tickets[index].price
        if (props.tickets[index].price_old === props.tickets[index].price) {
          delete props.tickets[index].price_old
        }
      })
      totalRemainderPoints.value += userPoints.value - totalNumberPointsToPay.value
      appliedPoints.value = true
    }

    // Применяем баллы к заказу и делаем перерасчет
    const applyPointsToOrder = () => {
      applyPoints()
      calculationOrder()
      calculationTotalPriceWithCommission()
      changeButtonsDisabledState(false)
    }

    // Применяем скидку к стоимости мест
    const applyBeneficiary = () => {
      props.tickets.forEach((ticket, index) => {
        props.tickets[index].price_old = props.tickets[index].price
        props.tickets[index].price = applyDiscountBeneficiary(props.tickets[index].price, userBeneficiaryResponse.value.beneficiary_percent)
      })
      appliedBeneficiary.value = true
    }

    // Применяем скидку к заказу и делаем перерасчет
    const applyBeneficiaryToOrder = () => {
      applyBeneficiary()
      calculationOrder()
      calculationTotalPriceWithCommission()
      changeButtonsDisabledState(false)
    }

    /**
     * Расчет стоимости заказа в зависимости от того применяется скидка или нет
     * @param type (promocode, points, beneficiary)
     * */
    const calculation = (type = null) => {
      changeButtonsDisabledState(true)
      switch (type) {
        case 'promocode':
          if (!orderData.value.promocode || !orderData.value.promocode.trim()) {
            changeButtonsDisabledState(false)
            return
          }
          if (isPromocodeApplied.value) {
            return
          }
          orderData.value.loyalty_type = 'promocode'
          applyPromoCodeToOrder()
          break
        case 'points':
          orderData.value.loyalty_type = 'points'
          orderData.value.promocode = null
          applyPointsToOrder()
          break
        case 'beneficiary':
          orderData.value.loyalty_type = 'beneficiary'
          orderData.value.promocode = null
          applyBeneficiaryToOrder()
          break
        default:
          orderData.value.loyalty_type = 'none'
          orderData.value.promocode = null

          calculationOrder()
          calculationTotalPriceWithCommission()
          changeButtonsDisabledState(false)
          break
      }
    }

    // Сброс скидки
    const resetDiscount = () => {
      props.tickets.forEach((ticket, index) => {
        if (typeof ticket.price_old !== 'undefined') {
          props.tickets[index].price = ticket.price_old
          delete props.tickets[index].price_old
        }
      })
      oldTotalPrice.value = 0
      discount.value = 0
      appliedPoints.value = false
      appliedBeneficiary.value = false
      isPromocodeApplied.value = false
      totalRemainderPoints.value = 0
      totalNumberPointsToPay.value = 0
      ticketsWithPromocode.value = 0
      promocode.value.discount = null
      calculation()
      changeButtonsDisabledState(false)
    }

    const returnBack = () => {
      step.value -= 1
      resetDiscount()
    }

    const close = () => {
      context.emit('close')
      resetDiscount()
    }

    // Если в ссылке пришел промокод применяем его
    const linkPromocode = () => {
      if (props.tPromo.length && props.tPromo !== 'null') {
        orderData.value.promocode = props.tPromo
        applyPromoCodeToOrder()
      }
    }

    const onSubmitStep1 = async () => {
      btnPaymentDisabled.value = true

      try {
        await fetchLoyaltySystemDataForUser()

        if (await checkOrderLimits()) return

        step.value = 2
        basketHall()
        linkPromocode()
      } catch (error) {
        const message = error.response?.data?.message || 'Доступ запрещен или ошибка сервера'
        showModal(message, 'Ошибка')
      } finally {
        btnPaymentDisabled.value = false
      }
    }

    const checkOrderLimits = async () => {
      try {
        const queryParams = {
          name: orderData.value.name,
          phone: orderData.value.phone,
          email: orderData.value.email,
          tickets_count: props.tickets.length
        };

        const { data } = await store.dispatch('widget/checkOrderLimits', queryParams);

        if (data.limit_exceeded) {
          context.emit('show-modal-corporate', {
            ...data,
            ...queryParams
          });
          return true
        }
      } catch (error) {
        console.error('Ошибка проверки лимитов:', error)
      }

      return false
    };

    watch(() => store.state.app.settings.sbp_enabled, newSbpEnabled => {
      sbpEnabled.value = newSbpEnabled
    })

    // При монтировании компонента
    onMounted(() => {
      sbpEnabled.value = store.state.app.settings.sbp_enabled
      calculation()
      fetchSettingsFileDoc()
      // Свежие настройки с сервера, игнорируя localStorage кэш
      store.dispatch('widget/fetchSettings', { force: true })
        .then(response => response.data)
        .then(response => {
          store.commit('app/SET_SETTINGS', response.data)
        })
    })

    // Отлавливаем изменение колиества билетов
    watch(() => props.tickets, newTickets => {
      if (!newTickets.length) {
        showModal('Вы удалили все места, для продолжения нужно вернуться и выбрать место.')
        changeButtonsDisabledState(true)
        return
      }
      changeButtonsDisabledState(false)
      if (hasPoints.value || hasBeneficiary.value) {
        changeShowNotificationState()
      }
      calculation()
    })

    // Удаляем элемент из схемы по ID
    const removeElement = id => {
      resetDiscount()
      context.emit('removeElementFromSeats', id)
      changeButtonsDisabledState(!props.tickets.length)
      calculation()
    }

    const orderProcessCancelSale = (message, title) => {
      const notAvailable = document.getElementById('notAvailable')
      const notAvailableTitle = notAvailable.querySelector('.modal-attention__title')
      const notAvailableMessage = notAvailable.querySelector('.modal-attention__body')
      const btnBars = document.querySelector('.btn-bars')
      const mainContent = document.querySelector('.main-content')
      if (notAvailableTitle) notAvailableTitle.textContent = title ?? 'Внимание!'
      if (notAvailableMessage) notAvailableMessage.textContent = message
      notAvailable.classList.add('show')
      btnBars.classList.add('d-none')
      mainContent.classList.add('d-none')
    }

    watch(() => totalPriceWithCommission.value, newTotalPriceWithCommission => {
      if (newTotalPriceWithCommission > 0) {
        showPaymentBtnBlock.value = true
      } else {
        showPaymentBtnBlock.value = false
      }
    })

    return {
      sslCheckResult,
      buttonPaymentGateway1Enabled,
      buttonPaymentGateway2Enabled,
      buttonPaymentGateway1Type,
      buttonPaymentGateway2Type,
      totalPrice,
      totalPriceWithCommission,
      showPaymentBtnBlock,
      oldTotalPrice,
      discount,
      COMMISSION,
      hasPoints,
      userPointsResponse,
      hasBeneficiary,
      userBeneficiaryResponse,
      appliedPoints,
      appliedBeneficiary,
      userPoints,
      percentPointsToPay,
      totalRemainderPoints,
      totalNumberPointsToPay,
      totalNumberPointsToPayPlanned,
      showNotificationPoints,
      showNotificationBeneficiary,
      bookingSeatExcessNumber,
      btnPaymentDisabled,
      btnApplyPromoCodeDisabled,
      btnApplyPointsDisabled,
      btnApplyBeneficiaryDisabled,
      promocode,

      // Новый расчет
      loyaltyTypesList,
      removeElementTicket,
      step,
      orderData,
      getValidationState,
      refFormObserver,
      resetForm,
      // totalPrice,
      onSubmitStep1,
      // ticketsOld,
      returnBack,
      close,
      calculation,
      resetDiscount,
      removeElement,
      applyBeneficiary,
      applyPoints,
      basketHall,
      fetchLoyaltySystemDataForUser,
      sbpEnabled,
      checkAgreementUser,
      checkAgreementPersonal,
      getDocUrl,
      ticketsWithPromocode,
      paymentButtons,
      handlePaymentClick,
      showSberBanner,
      limitError,
    }
  },
}
</script>
<style scoped lang="scss">
$mobile: 899px;

.sidebar-order {
  position: absolute;
  z-index: 11;
  top: 0;
  right: 0;
  width: 360px;
  height: 100%;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  @media (max-width: $mobile) {
    width: 100%;
  }
}

.sidebar-header {
  padding: 25px 20px;
  display: flex;
  align-items: center;
}

.sidebar-title {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  flex-grow: 1;
  padding-left: 15px;
}

.sidebar-body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;

  &__scroll {
    padding: 25px;
    overflow: auto;
  }

  &__card-info {
    text-align: center;
    color: #444444;
    font-size: 11px;
    margin-top: 8px;
  }
}

.ticket-item {
  display: flex;
  align-items: end;
  margin-bottom: 1rem;
}

.ticket-item-detail {
  flex-basis: 70%;
  color: #6E6B7B;
}

.ticket-item-price {
  text-align: right;
  font-weight: bold;
  flex-basis: 30%;

  &__old {
    font-weight: normal;
    text-decoration: line-through;
    color: #82868b;
  }
}

.tickets-count {
  font-weight: 600;
  margin-bottom: 5px;
}

#promocode:disabled {
  border-color: #28c76f;
}

#promo {
  margin-top: 1rem;
}

.alert-sertificat-sber {
  background-color: #f8f8f8;
  padding: 0.438rem 1rem;
  font-size: 13px;
  border-radius: 0.357rem;
  overflow: hidden;
  margin-top: 1rem;
}

.modal-attention {
  width: 100%;
  max-width: 358px;
  margin: 0 auto;
  padding: 37px 24px;
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  display: none;

  &.maxticketsbuy {
    display: block;
  }

  &.show {
    display: block;
  }

  &.long {
    max-width: 576px;

    a {
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  }

  &__header {
    margin-bottom: 15px;
    text-align: center;
  }

  &__title {
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: #5E5873;
  }

  &__body {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #6E6B7B;
    margin-bottom: 24px;

    p {
      margin: 0 0 16px;
    }
  }

  &__footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
}

.gotopay {
  background: linear-gradient(90deg, rgba(141, 226, 1, 1) 0%, rgba(39, 220, 43, 1) 20%, rgba(60, 224, 175, 1) 80%, rgba(23, 203, 222, 1) 100%);
  display: block;
  width: 100%;
  border: none;
  padding-top: 11px;
  padding-bottom: 9px;
}

.icon-sber-pay {
  display: inline-block;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADwSURBVHgBjVLREYIwDG3LHd+6gU4gI+AEuoE6gTqBOIGM4AaMwDEBbuAI+A0H9QUTr2oVc/cuvfL68hKi1VtYa2OkWdd1Y2NMhXOhtb4oX4A8ATEHrAc5fReukQdAiWOEfITyFFU0ZTzY4P7mq3AluGpfnGTII9W27Y4sDDzYglM9hXEoybMQSMQhj4CT21dfiS5ATIXIBFJcsm0rQmyxNB4re84ZV54HQZCy4JqG9WFPFEFOeitOsMWSlBKy0DRNrH4EW3tYJbWhkXt/S13XkXO5AiIhAwced0U85enj/M8aaZ8VpIUsLHotwjB8Wdg7wk1Wv+uapxMAAAAASUVORK5CYII=');
  background-repeat: no-repeat;
  width: 13px;
  height: 18px;
  margin: 0 5px;
  vertical-align: middle;
}
.icon-sbp {
  display: inline-block;
  background-image: url("data:image/svg+xml;base64,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");
  background-repeat: no-repeat;
  width: 39px;
  height: 24px;
  margin: 0 5px;
  vertical-align: middle;
}
.icon-pay-card {
  display: inline-block;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQzNzUgNC4yNUg0LjU2MjVDMy4zNTQzOCA0LjI1IDIuMzc1IDUuMjI5MzggMi4zNzUgNi40Mzc1VjE0LjU2MjVDMi4zNzUgMTUuNzcwNiAzLjM1NDM4IDE2Ljc1IDQuNTYyNSAxNi43NUgxNi40Mzc1QzE3LjY0NTYgMTYuNzUgMTguNjI1IDE1Ljc3MDYgMTguNjI1IDE0LjU2MjVWNi40Mzc1QzE4LjYyNSA1LjIyOTM4IDE3LjY0NTYgNC4yNSAxNi40Mzc1IDQuMjVaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yLjM3NSA4SDE4LjYyNU01LjUgMTIuMjE4OEg3LjM3NVYxM0g1LjVWMTIuMjE4OFoiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS44NzUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==");
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
  margin: 0 5px;
  vertical-align: text-bottom;
}

.go-pay-card {
  margin-top: 12px;
  width: 100%;
  text-align: center;
  padding: 0.386rem 1.5rem;
  border-radius: 0.358rem;
  color: #fff;
  height: 40px;
  background-color: #7367f0;
  border: solid 1px #7367f0;
}
.go-pay-card:hover{
  box-shadow: 0 8px 25px -8px #7367f0;
}
.go-pay-card:active, .go-pay-card:focus{
  background-color: #7367f0;
}
.go-pay-card:disabled{
  opacity: 0.65;
  pointer-events: none;
}
.go-pay-card:disabled:hover{
  box-shadow: none;
}

.go-pay-card.btn-sber-pay{
  background-color: transparent;
  color: #28C76F;
  border: solid 1px #28C76F;
}
.go-pay-card.btn-sber-pay:hover{
  box-shadow: 0px 4px 14px 0px rgba(40, 199, 111, 0.38);
}
.go-pay-card.btn-sber-pay .icon-pay-card {
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQzNzUgNC4yNUg0LjU2MjVDMy4zNTQzOCA0LjI1IDIuMzc1IDUuMjI5MzggMi4zNzUgNi40Mzc1VjE0LjU2MjVDMi4zNzUgMTUuNzcwNiAzLjM1NDM4IDE2Ljc1IDQuNTYyNSAxNi43NUgxNi40Mzc1QzE3LjY0NTYgMTYuNzUgMTguNjI1IDE1Ljc3MDYgMTguNjI1IDE0LjU2MjVWNi40Mzc1QzE4LjYyNSA1LjIyOTM4IDE3LjY0NTYgNC4yNSAxNi40Mzc1IDQuMjVaIiBzdHJva2U9IiMyOEM3NkYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIuMzc1IDhIMTguNjI1TTUuNSAxMi4yMTg4SDcuMzc1VjEzSDUuNVYxMi4yMTg4WiIgc3Ryb2tlPSIjMjhDNzZGIiBzdHJva2Utd2lkdGg9IjEuODc1IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=')
}
.go-pay-card.btn-sber-pay .icon-sber-pay {
  background-image: url('data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkVEOEVBQTczQzIxRTExRUY5RUREODVEOTY4NzlCNUYyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkVEOEVBQTc0QzIxRTExRUY5RUREODVEOTY4NzlCNUYyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RUQ4RUFBNzFDMjFFMTFFRjlFREQ4NUQ5Njg3OUI1RjIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RUQ4RUFBNzJDMjFFMTFFRjlFREQ4NUQ5Njg3OUI1RjIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7VGcmFAAAA70lEQVR42oRS2w3CMAxsog5QNigTtBsAEwATAJ98QScAJqAbABNQJgj88VeYgG5AR8AnXSQrqoqlUx66OzuOTfRcR0GMBZlgIPgKHoKXJsRqnwpOFIVxF6wEDQ5WCWpBLjgIhgLDFeRWOxgpDwLH88S7dQR4R5gg04wXfYKNqiSBaMGavWCryAndSzYDxq2l+q2IIH1YQU2TggKEsx2lFFyv6p0l90skiZk2UyIQKhLKoHMj8JHpxr/R/4P37QNBSs7F0q3hx6Y97XbkVZZuc/9IdjNX5B0bkpDX+DHy7URJ539jZDoGFu7TvoH9CTAA3Rg7U9pogcsAAAAASUVORK5CYII=');
}

.go-pay-card.btn-vtb-pay{
  background-color: transparent;
  color: #3261ec;
  border: solid 1px #3261ec;
}
.go-pay-card.btn-vtb-pay:hover{
  box-shadow: 0px 4px 14px 0px rgb(30, 75, 210);
}
.go-pay-card.btn-vtb-pay .icon-pay-card {
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQzNzUgNC4yNUg0LjU2MjVDMy4zNTQzOCA0LjI1IDIuMzc1IDUuMjI5MzggMi4zNzUgNi40Mzc1VjE0LjU2MjVDMi4zNzUgMTUuNzcwNiAzLjM1NDM4IDE2Ljc1IDQuNTYyNSAxNi43NUgxNi40Mzc1QzE3LjY0NTYgMTYuNzUgMTguNjI1IDE1Ljc3MDYgMTguNjI1IDE0LjU2MjVWNi40Mzc1QzE4LjYyNSA1LjIyOTM4IDE3LjY0NTYgNC4yNSAxNi40Mzc1IDQuMjVaIiBzdHJva2U9IiMzMjYxZWMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIuMzc1IDhIMTguNjI1TTUuNSAxMi4yMTg4SDcuMzc1VjEzSDUuNVYxMi4yMTg4WiIgc3Ryb2tlPSIjMzI2MWVjIiBzdHJva2Utd2lkdGg9IjEuODc1IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=')
}

.promo{
  border-top: 1px solid #EBE9F1;
  padding-top: 15px;
}

.payment-buttons{
  border-top: 1px solid #EBE9F1;
  padding: 20px 0;
}
.payment-buttons__head{
  font-size: 16px;
  line-height: 20px;
  color: #6E6B7B;
}
.btn-sbp{
  background-color: #1E1155;
  border-color: #1E1155;
}
.btn-sbp:hover{
  box-shadow: 0px 4px 14px 0px rgba(115, 103, 240, 0.38);
}
.btn-sbp:active, .btn-sbp:focus{
  background-color: #0F0738;
}
.btn-sbp:disabled{
  border-color: #4B456A;
  background-color: #4B456A;
}

/** кнопка удаления места */
.v-reset-input {
  top: 11px;
  right: 28px;
  width: 14px;
  height: 21px;
  /*font-size: 0.9em;*/
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
}
.v-reset-input, .v-reset-input svg {
  color: red;
  display: none;
}
.v-reset-input.v-reset-input-active, .v-reset-input.v-reset-input-active svg {
  display: inline-block;
}

.loyalty-block{
  margin-top: 30px;
  &__item{
    width: 100%;
    padding: 24px 0;
    border-bottom: 1px solid #EBE9F1;
    &:first-child{
      border-top: 1px solid #EBE9F1;
    }
    &:last-child{
      border-bottom: 0px solid #EBE9F1;
    }
    .collapsed{

    }
  }
  &__head{
    color: #B9B9C3;
    position: relative;
    font-size: 16px;
    line-height: 20px;
    &:after {
      content: '';
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100%;
      height: 18px;
      width: 18px;
      display: inline-block;
      position: absolute;
      right: 0;
      top: 1px;
      transform: rotate(90deg);
      transition: all 0.2s ease-out;
      opacity: .5;
    }
    &.not-collapsed{
      color: #6E6B7B;
      &:after {
        transform: rotate(-90deg);
        opacity: 1;
      }
    }
  }
  &__body{
    margin-top: 16px;
  }
}

.loyalty-points{
  &__item{
    position: relative;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    .alert{
      padding: 4px 8px;
    }
  }
  &__available{
    font-size: 21px;
    line-height: 26px;
    padding-right: 10px;
    font-weight: 500;
  }
  &__delete{
    position: absolute;
    top: -14px;
    right: -14px;
    color: #EA5455;
    padding: 14px;
    text-decoration: none;
  }
  &__apply{
    margin-top: 16px;
  }
  &__info{
    margin-bottom: 12px;
    color: #B9B9C3;
    font-size: 12px;
    line-height: 16px;
  }
  &__notification{
    margin-top: 12px;
    color: #B9B9C3;
    font-size: 12px;
    line-height: 16px;
  }
  &__used{
    font-weight: 600;
  }
  &__balans{
    color: #28C76F;
    margin-top: 10px;
  }
}
</style>
